import styled from 'styled-components';
import PhoneField, { type PhoneFieldProps } from '../../../components/fields/ci/PhoneField';
import { porscheInputNumberAffixStyle, porscheInputStyle } from './shared';

const Container = styled.div`
    & .ant-form-item-label {
        padding-bottom: 4px;
    }

    & .ant-form-item-label > label {
        font-weight: 400;
    }

    & .ant-form-item-label > label > p {
        opacity: 1 !important;
    }

    & .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
        order: 1;
        margin-right: 0px;
        margin-left: 4px;
    }

    & .ant-input-group > {
        ${porscheInputNumberAffixStyle}

        ${porscheInputStyle}
    }
`;

const PhoneAndPrefixField = (props: PhoneFieldProps) => (
    <Container>
        <PhoneField {...props} />
    </Container>
);

export default PhoneAndPrefixField;
